export default __webpack_public_path__ + "static/media/038-thermometer.080f9a03.svg";